import React,{useState} from 'react'
import {useNavigate} from 'react-router-dom'

export default function Signup(props) {
  const [credentials, setCredentials] = useState({name:"",email:"",password:""})
  const [loading,setLoading]=useState(false);
  let navigate=useNavigate();


  const handleSubmit=async (e)=>{
    const {name,email,password}=credentials;
    e.preventDefault();
    setLoading(true);
    const response=await fetch("https://inotebook-backend-urbn.onrender.com/api/auth/createuser",{
      method: 'POST',
      headers:{
        'Content-Type':'application/json'
      },
      body: JSON.stringify({name,email,password})
    });
    const json=await response.json()
      if(json.success){
        // save the auth token redirect to the page 
      localStorage.setItem('token',json.authToken)
      setLoading(false);
      navigate("/home");
      props.showAlert("Sign up successfully","success")
      }
      else{
        setLoading(false);
        props.showAlert("Invalid Credentials","danger")
      }
  }
  
  const onChange=(e)=>{
    setCredentials({...credentials,[e.target.name]: e.target.value})
  }

  return (
    <div className='container my-3'>
      <h2>Create a account</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">Name</label>
          <input type="text" className="form-control" id="name" onChange={onChange} value={credentials.name} name="name" />
        </div>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">Email address</label>
          <input type="email" className="form-control" id="email" onChange={onChange} value={credentials.email} name="email" />
        </div>
        <div className="mb-3">
          <label htmlFor="password" className="form-label">Password</label>
          <input type="password" value={credentials.password} name="password" onChange={onChange} className="form-control" id="password" required minLength={5}/>
        </div>
        {
          loading? <img alt="Loading-icon" className='loading-img' src='https://www.wpfaster.org/wp-content/uploads/2013/06/loading-gif.gif'></img> : <button type="submit" className="btn btn-primary" >Submit</button>
        }
      </form>
    </div>
  )
}
